import PatternRegex from '@/data/usecases/data-format-pattern/pattern-regex'
import { Locale } from '@/domain/models/locale'
import Decimal from 'decimal.js-light'

const THREE_DIGITS_REGEX = /(\d{2})(\d)/
const FOUR_DIGITS_REGEX = /(\d{3})(\d)/
const CNPJ_VALID_DIGIT_REGEX = /(\d{4})(\d{1,2})$/

export const formatNumber = (number: number) => (number ?? 0).toLocaleString('pt-BR')

export const formatMoney = (
  value?: number,
  addPrefix: boolean = true,
  locale: Locale.Enum = Locale.Enum.BR
) => {
  return addPrefix
    ? (value ?? 0).toLocaleString(locale.value, {
        style: 'currency',
        currency: locale.currency,
        minimumFractionDigits: 2
      })
    : (value ?? 0).toLocaleString(locale.value, { minimumFractionDigits: 2 })
}

export const convertStringToDecimal = (value: string): Decimal => {
  const cents = PatternRegex.getOnlyNumbers(value)
  return new Decimal(cents).div(100)
}

const calculatePercentage = (totalValue: Decimal, percentage: number): Decimal => {
  const coParticipationValue = new Decimal(percentage).div(100)
  return totalValue.mul(coParticipationValue)
}

export const calculateCreditsValue = (
  value: string,
  coParticipation: number,
  balance: number
): string => {
  const totalValue = convertStringToDecimal(value)
  const coParticipationValue = calculatePercentage(totalValue, 100 - coParticipation)
  const balanceValue = new Decimal(balance)
  let creditsValue = coParticipationValue.greaterThan(balanceValue)
    ? balanceValue
    : coParticipationValue
  creditsValue = creditsValue.toDecimalPlaces(2, Decimal.ROUND_HALF_EVEN)

  return formatMoney(creditsValue.toNumber())
}

export const formatCNPJ = (cnpj: string) => {
  cnpj = PatternRegex.getOnlyNumbers(cnpj)
  cnpj = cnpj.replace(THREE_DIGITS_REGEX, '$1.$2')
  cnpj = cnpj.replace(FOUR_DIGITS_REGEX, '$1.$2')
  cnpj = cnpj.replace(FOUR_DIGITS_REGEX, '$1/$2')
  cnpj = cnpj.replace(CNPJ_VALID_DIGIT_REGEX, '$1-$2')
  return cnpj
}

export const booleanToValidString = (value?: boolean | null) => {
  return typeof value === 'boolean' ? (value ? 'true' : 'false') : undefined
}

export const toBoolean = (value?: string | null) => {
  return value === 'true'
}
